import {Component, Input} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-tab-task-leistung',
  templateUrl: './tab-task-leistung.component.html',
  styles: [
  ]
})
export class TabTaskLeistungComponent extends ExcTranslation {
  @Input()
  SummaryLeistungTable: any;
  @Input()
  ConfigLeistungTable: any;
  @Input()
  tableDrawerIsLoading: any | undefined;
  @Input()
  Events: ExgEventArgs | any;

  constructor(
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService,
    private excSecurity: ExcSecurityService
  ) {
    super();
  }

  onClickOpenServiceRecord(serviceRecord: any): void {
    this.appSvc.Leistungserfassung.Checkview.OpenTab(serviceRecord, {Events: this.Events});
  }



  sumTotal(serviceRecord: any): number {
    return (serviceRecord.leHonorarleistungSum || 0)
      + (serviceRecord.leFahrtkostenSum || 0)
      + (serviceRecord.leSonstigeKostenSum || 0)
      + (serviceRecord.leAuslagenSum || 0);
  }
}
